import { ApiDataSourceSpec, apiDataSource } from "@/io/datasource/ApiDatasource.ts";
import {
  AlertConfig,
  AlertSummary,
  CreateAlertConfig,
  EditAlertConfig,
  alertConfigSchema,
  alertSummarySchema,
} from "@/models/AlertModel.ts";
import { decamelizeObject } from "@/utils/caseUtils.ts";
import { cz } from "@/utils/zodUtils.ts";

export class AlertsRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  getAlertConfigList = (patientId: string): Promise<AlertConfig[]> => {
    return this.datasource.get(`/practitioner/alerts/configuration/${patientId}/`, cz.forcedArray(alertConfigSchema));
  };

  getAlertList = (patientId: string): Promise<AlertSummary[]> => {
    return this.datasource.get(`/practitioner/alerts/${patientId}/`, cz.forcedArray(alertSummarySchema));
  };

  createAlertConfig = (patientId: string, alertConfig: CreateAlertConfig): Promise<undefined> => {
    return this.datasource.post(`/practitioner/alerts/configuration/${patientId}/`, cz.ignore(), alertConfig);
  };

  editAlertConfig = (patientId: string, { id: alertConfigId, ...alertConfig }: EditAlertConfig): Promise<undefined> => {
    return this.datasource.patch(
      `/practitioner/alerts/configuration/${patientId}/${alertConfigId}/`,
      cz.ignore(),
      decamelizeObject(alertConfig as Record<string, unknown>),
    );
  };

  deleteAlertConfig = (patientId: string, alertConfigId: string): Promise<undefined> => {
    return this.datasource.delete(`/practitioner/alerts/configuration/${patientId}/${alertConfigId}/`, cz.ignore());
  };

  dismissAlert = (patientId: string, alertId: string): Promise<undefined> => {
    return this.datasource.delete(`/practitioner/alerts/${patientId}/${alertId}/`, cz.ignore());
  };
}
